import React from 'react'
import { Box, SimpleGrid, Text, Image, Flex, Button, Icon } from '@chakra-ui/react'
import { FiEdit2 } from 'react-icons/fi'
import { useQuery } from 'react-query'

const mockArtGroups = [
  {
    id: 1,
    backgroundColor: '#FFEB3B',
    images: [
      { id: 1, code: '4252', url: 'https://via.placeholder.com/300x200/FFEB3B/000000?text=Bulldog' },
      { id: 2, code: '3554', url: 'https://via.placeholder.com/300x200/FFEB3B/000000?text=Bulldog' },
      { id: 3, code: '3554 com tampa', url: 'https://via.placeholder.com/300x200/FFEB3B/000000?text=Bulldog' },
      { id: 4, code: '4010', url: 'https://via.placeholder.com/300x200/FFEB3B/000000?text=Bulldog' },
      { id: 5, code: '2008', url: 'https://via.placeholder.com/300x200/FFEB3B/000000?text=Bulldog' },
      { id: 6, code: '3687', url: 'https://via.placeholder.com/300x200/FFEB3B/000000?text=Bulldog' },
    ],
  },
  {
    id: 2,
    backgroundColor: '#FF9800',
    images: [
      { id: 7, code: '4252', url: 'https://via.placeholder.com/300x200/FF9800/000000?text=Bulldog' },
      { id: 8, code: '3554', url: 'https://via.placeholder.com/300x200/FF9800/000000?text=Bulldog' },
      { id: 9, code: '3554 com tampa', url: 'https://via.placeholder.com/300x200/FF9800/000000?text=Bulldog' },
      { id: 10, code: '4010', url: 'https://via.placeholder.com/300x200/FF9800/000000?text=Bulldog' },
      { id: 11, code: '2008', url: 'https://via.placeholder.com/300x200/FF9800/000000?text=Bulldog' },
      { id: 12, code: '3687', url: 'https://via.placeholder.com/300x200/FF9800/000000?text=Bulldog' },
    ],
  },
  {
    id: 3,
    backgroundColor: '#607D8B',
    images: [
      { id: 13, code: '4252', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 14, code: '3554', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 15, code: '3554 com tampa', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 16, code: '4010', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 17, code: '2008', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 18, code: '3687', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
    ],
  },
  {
    id: 4,
    backgroundColor: '#607D8B',
    images: [
      { id: 19, code: '4252', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 20, code: '3554', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 21, code: '3554 com tampa', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 22, code: '4010', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 23, code: '2008', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
      { id: 24, code: '3687', url: 'https://via.placeholder.com/300x200/607D8B/FFFFFF?text=Bulldog' },
    ],
  },
]

export function ArtGallery({ categoria, tema }) {
  const { data: artGroups = mockArtGroups } = useQuery(['artGallery', categoria, tema], async () => {
    await new Promise((resolve) => setTimeout(resolve, 500))
    return mockArtGroups
  })

  const handleEdit = (groupId) => {
    console.log(`Editando grupo ${groupId}`)
  }

  return (
    <Box>
      {artGroups.map((group) => (
        <Box key={group.id} mb={8} borderWidth="1px" borderRadius="lg" p={4} bg="white" borderColor="#F0F0F0" position="relative">
          <Flex justifyContent="flex-end" mb={4} mt={1}>
            <Button
              rightIcon={<Icon as={FiEdit2} />}
              variant="outline"
              size="sm"
              borderColor="#378BBF"
              color="#378BBF"
              onClick={() => handleEdit(group.id)}
              px={4}
            >
              Editar
            </Button>
          </Flex>

          <SimpleGrid columns={{ base: 2, sm: 3, md: 6 }} spacing={{ base: 3, md: 4 }} my={1}>
            {group.images.map((image) => (
              <Box key={image.id}>
                <Text fontSize="sm" fontWeight="medium" mb={1} textAlign="center" color="gray.700">
                  Cod - {image.code}
                </Text>
                <Image
                  src={image.url}
                  alt={`Código ${image.code}`}
                  borderRadius="md"
                  objectFit="cover"
                  w="100%"
                  h="auto"
                  border="1px solid"
                  borderColor="gray.200"
                />
              </Box>
            ))}
          </SimpleGrid>
        </Box>
      ))}
    </Box>
  )
}
